import React, { useState, useEffect } from "react";
import "./navigation.css";

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
      <div className="nav-container">
        {/* Logo */}
        <a className="navbar-brand" href="#page-top">
          <img src="img/AerolinesLogo.png" alt="Aerolines Logo" />
        </a>

        {/* Toggle Button */}
        <button
          className={`menu-toggle ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Menu */}
        <ul className={`nav-menu ${menuOpen ? "active" : ""}`}>
          {[
            ["Home", "/"],
            ["About", "#about"],
            ["Electrical Engineering", "/electrical-engineering-solutions"],
            ["Facility Maintenance", "/facility-maintenance-solutions"],
            ["Our Services", "#services"],
            ["Past Projects", "#portfolio"],
            ["Contact Us", "#contact"],
          ].map(([label, link]) => (
            <li key={label}>
              <a href={link} onClick={closeMenu}>
                {label}
              </a>
            </li>
          ))}

          {/* WhatsApp */}
          <li className="whatsapp">
            <a
              href="https://wa.me/6580345706?text=Hi%20Aerolines%20!"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-whatsapp"></i>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};
